import { ICommonIconProps } from './types';
/**
 * -----------------------------------------------------------------------------
 * It renders a comment box like icon with cross round in the center.
 */
export function QuoteRejectedIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" height={24} viewBox="0 0 24 24">
      <circle
        cx={12}
        cy={18}
        r={4}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m11 19 2-2M11 17l2 2M8 18H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-3M7 11h10M7 7h10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
